import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oauth2-code-pkce";
import { authConfig, authEnabled } from "./auth.js";
import App from "./App.js";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);

// Without a configured IdP the provider would try to build endpoints from an
// empty issuer and throw on mount. Rendering App directly keeps the app
// usable (and honest about why sign-in is unavailable) until the client id
// arrives from the Platform Team.
root.render(
  <React.StrictMode>
    {authEnabled ? (
      <AuthProvider authConfig={authConfig}>
        <App />
      </AuthProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
